// import React, { useState } from "react";
// import { FiMail } from "react-icons/fi";
// import { AiOutlineMenu, AiOutlineClose } from "react-icons/ai";
// import logo from "../../assets/AssestEyeLogoRedirect.svg";
// import Dronejteklogo from "../../assets/LogoAsses.svg";
// import LanguageSwitcher from "../shared/LanguageSwitcher";
// import { useTranslation } from "react-i18next";
// import { Link } from "react-router-dom";

// const Navbar = () => {
//   const { t } = useTranslation();

//   const [isMenuOpen, setIsMenuOpen] = useState(false);

//   return (
//     <header className="fixed top-0 w-full z-50 bg-white">
//       <div className="flex justify-between items-center px-6 py-4 md:px-10">
//         {/* Logo */}
//         <div className="flex items-center gap-2">
//           <Link to="/">
//             <img src={logo} alt={t("navbar.logoAlt")} />
//           </Link>
//         </div>

//         {/* Desktop Nav Links */}
//         <nav className="hidden md:flex gap-10 text-gray-700 font-medium">
//           <Link to="/" className="hover:text-black">
//             {t("navbar.home")}
//           </Link>
//           <Link to="/about" className="hover:text-black">
//             {t("navbar.about")}
//           </Link>
//           <Link to="/contact" className="hover:text-black">
//             {t("navbar.contact")}
//           </Link>
//         </nav>

//         {/* Right Section */}
//         <div className="hidden md:flex items-center gap-6">
//           <LanguageSwitcher variant="dropdown" />
//           <a href="https://dronetjek.dk/" target="_blank" rel="noopener noreferrer">
//             <img src={Dronejteklogo} alt={t("navbar.emailUsAlt")} />
//           </a>
//         </div>

//         {/* Hamburger Icon for Mobile */}
//         <button
//           className="md:hidden text-gray-700 text-2xl"
//           onClick={() => setIsMenuOpen(!isMenuOpen)}
//         >
//           {isMenuOpen ? <AiOutlineClose /> : <AiOutlineMenu />}
//         </button>
//       </div>

//       {/* Mobile Menu */}
//       {isMenuOpen && (
//         <div className="md:hidden bg-white shadow-lg">
//           <nav className="flex flex-col gap-4 text-gray-700 font-medium px-6 py-4">
//             <Link to="/" className="hover:text-black" onClick={() => setIsMenuOpen(false)}>
//               {t("navbar.home")}
//             </Link>
//             <Link to="/about" className="hover:text-black" onClick={() => setIsMenuOpen(false)}>
//               {t("navbar.about")}
//             </Link>
//             <Link to="/contact" className="hover:text-black" onClick={() => setIsMenuOpen(false)}>
//               {t("navbar.contact")}
//             </Link>
//           </nav>

//           {/* Language Switcher and Logo */}
//           <div className="flex flex-col items-center gap-4 px-6 pb-4">
//             <LanguageSwitcher variant="dropdown" />
//             <a href="https://dronetjek.dk/" target="_blank" rel="noopener noreferrer">
//               <img src={Dronejteklogo} alt={t("navbar.emailUsAlt")} />
//             </a>
//           </div>
//         </div>
//       )}
//     </header>
//   );
// };

// export default Navbar;

import React, { useEffect, useState } from "react";
import { AiOutlineMenu, AiOutlineClose } from "react-icons/ai";
import logo from "../../assets/AssestEyeLogoRedirect.svg";
import Dronejteklogo from "../../assets/LogoAsses.svg";
import LanguageSwitcher from "../shared/LanguageSwitcher";
import { useTranslation } from "react-i18next";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const Navbar = () => {
  const { t } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (isMenuOpen) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, [isMenuOpen]);
  return (
    <header className="fixed top-0 w-full z-50 bg-white">
      <div className="flex justify-between items-center px-10 py-4 md:px-10">
        {/* Logo */}
        <div className="flex items-center gap-2">
          <Link to="/">
            <img src={logo} alt={t("navbar.logoAlt")} />
          </Link>
        </div>

        {/* Desktop Nav Links */}
        <nav className="hidden md:flex gap-10 text-gray-700 font-medium absolute left-1/2 transform -translate-x-1/2">
          <NavLink
            to="/"
            className={({ isActive }) =>
              isActive
                ? "text-green-700 font-bold border-b-2 border-green-700 pb-1"
                : "hover:text-black"
            }
          >
            {t("navbar.home")}
          </NavLink>
          <NavLink
            to="/about"
            className={({ isActive }) =>
              isActive
                ? "text-green-700 font-bold border-b-2 border-green-700 pb-1"
                : "hover:text-black"
            }
          >
            {t("navbar.about")}
          </NavLink>
          <NavLink
            to="/contact"
            className={({ isActive }) =>
              isActive
                ? "text-green-700 font-bold border-b-2 border-green-700 pb-1"
                : "hover:text-black"
            }
          >
            {t("navbar.contact")}
          </NavLink>
        </nav>

        {/* Right Section */}
        <div className="hidden md:flex items-center gap-6">
          <LanguageSwitcher variant="dropdown" />
          <button
            className="border border-green-700 rounded-sm px-4 py-2 text-green-700 hover:bg-secondaryColor hover:text-white"
            onClick={() => navigate("/login")}
          >
            Login
          </button>
          <a href="https://dronetjek.dk/" target="_blank" rel="noopener noreferrer">
            <img src={Dronejteklogo} alt={t("navbar.emailUsAlt")} style={{ height: "40px" }} />
          </a>
        </div>

        {/* Hamburger Icon for Mobile */}
        <button className="md:hidden text-gray-700 text-2xl" onClick={() => setIsMenuOpen(true)}>
          <AiOutlineMenu />
        </button>
      </div>

      {/* Mobile Drawer */}
      <AnimatePresence>
        {isMenuOpen && (
          <>
            {/* Overlay */}
            <motion.div
              className="fixed inset-0 bg-black bg-opacity-40 z-40"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setIsMenuOpen(false)}
            />

            {/* Drawer */}
            <motion.div
              className="fixed top-0 right-0 h-full w-64 bg-white shadow-lg z-50 flex flex-col"
              initial={{ x: "100%" }}
              animate={{ x: 0 }}
              exit={{ x: "100%" }}
              transition={{ type: "tween", duration: 0.3 }}
            >
              <div className="flex justify-between items-center px-8 py-4 border-b">
                <span className="text-lg font-semibold">{t("navbar.menu")}</span>
                <button className="text-gray-700 text-2xl" onClick={() => setIsMenuOpen(false)}>
                  <AiOutlineClose />
                </button>
              </div>

              <nav className="flex flex-col gap-4 text-gray-700 font-medium px-6 py-4">
                <Link to="/" onClick={() => setIsMenuOpen(false)}>
                  {t("navbar.home")}
                </Link>
                <Link to="/about" onClick={() => setIsMenuOpen(false)}>
                  {t("navbar.about")}
                </Link>
                <Link to="/contact" onClick={() => setIsMenuOpen(false)}>
                  {t("navbar.contact")}
                </Link>
              </nav>

              <div className="mt-auto flex flex-col items-start gap-4 pb-6 px-6">
                <LanguageSwitcher variant="dropdown" />
                <a href="https://dronetjek.dk/" target="_blank" rel="noopener noreferrer">
                  <img
                    src={Dronejteklogo}
                    alt={t("navbar.emailUsAlt")}
                    style={{ height: "40px" }}
                  />
                </a>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Navbar;
